module.exports = __webpack_public_path__ + "img/about_bg_sign.9e8e4763.png";